export const PERMISSION_PRESETS = {
  admin: {
    dashboard: { on: true },
    patients: {
      on: true,
      create: true,
      update: true,
      delete: true,
    },
    treatmentPlans: {
      on: true,
      create: true,
      update: true,
      delete: true,
      duplicate: true,
      sendToPatient: true,
    },
    appointments: {
      on: true,
      create: true,
      update: true,
      delete: true,
    },
    employees: { on: true, create: true, update: true, delete: true },
    servicesAndServicesGroups: {
      on: true,
      create: true,
      update: true,
      delete: true,
    },
    professionsAndProfessionGroups: {
      on: true,
      create: true,
      update: true,
      delete: true,
    },
    settings: { on: true, modules: true, invoices: true, users: true },
  },
  employee: {
    dashboard: { on: true },
    patients: {
      on: true,
      create: true,
      update: true,
      delete: true,
    },
    treatmentPlans: {
      on: true,
      create: true,
      update: true,
      delete: true,
      duplicate: true,
      sendToPatient: true,
    },
    appointments: {
      on: true,
      create: true,
      update: true,
      delete: true,
    },
    employees: { on: false, create: false, update: false, delete: false },
    servicesAndServicesGroups: {
      on: true,
      create: false,
      update: false,
      delete: false,
    },
    professionsAndProfessionGroups: {
      on: true,
      create: false,
      update: false,
      delete: false,
    },
    settings: { on: false, modules: false, invoices: false, users: false },
  },
  guest: {
    dashboard: { on: false },
    patients: {
      on: true,
      create: false,
      update: false,
      delete: false,
    },
    treatmentPlans: {
      on: true,
      create: false,
      update: false,
      delete: false,
      duplicate: false,
      sendToPatient: false,
    },
    appointments: {
      on: true,
      create: true,
      update: true,
      delete: true,
    },
    employees: { on: false, create: false, update: false, delete: false },
    servicesAndServicesGroups: {
      on: false,
      create: false,
      update: false,
      delete: false,
    },
    professionsAndProfessionGroups: {
      on: false,
      create: false,
      update: false,
      delete: false,
    },
    settings: { on: false, modules: false, invoices: false, users: false },
  },
};
